import {all, fork} from 'redux-saga/effects'
import {saga as heartbeatSaga, SagaDependencies as HeartbeatSagaDependencies} from './heartbeat'
import * as model from './model'
import * as persist from './persist'
import reducer from './reducer'
import loginSaga, {IDependencies as LoginSagaDependencies} from './saga'

export default reducer
export * from './actions'
export {actions as heartbeatActions} from './heartbeat'

export {model}
export {persist}
export type ISagaDependencies =
  LoginSagaDependencies
  & HeartbeatSagaDependencies
export function* saga(dependencies: ISagaDependencies) {
  yield all([
    fork<HeartbeatSagaDependencies>(heartbeatSaga, dependencies),
    fork<LoginSagaDependencies>(loginSaga, dependencies),
  ])
}
export * from './selectors'



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/login/index.ts